import type { ReactNode } from "react";

import { PortalHead, PortalPage } from "@/features/portal/components/portal-chrome";

/** A blog page in the portal's chrome: the head card with whatever opens the page, then the content. */
export const BlogPage = ({ hero, children }: { hero?: ReactNode; children: ReactNode }) => (
  <PortalPage head={<PortalHead>{hero}</PortalHead>}>{children}</PortalPage>
);
